module.exports = __webpack_public_path__ + "static/media/establishmentid1.cc9cf12f.svg";